import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=2f2d5218&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=2f2d5218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d5218",
  null
  
)

export default component.exports